import { styled } from 'styles';

export const TableHeaderRow = styled.div`
  display: flex;
  min-width: 100%;
  width: fit-content;
`;

export const StyledTableHeader = styled.div`
  user-select: none;
`;

TableHeaderRow.displayName = 'TableHeaderRow';
StyledTableHeader.displayName = 'TableHeader.Styled';
